import {getAuthClient} from "@trumpf/ux.utils";

const SCOPE = "notificationmanagement";
const TOKEN_RETRIEVAL_TIMEOUT = 30000;
const authClient = getAuthClient(SCOPE);

let sharedPendingTokenPromise: Promise<string | null> | null = null;
let unsubscribeFromAuthClient: (() => void) | null = null;

const authConsumers = new Set<string>();

export const getAuthToken = async () => {
	if (!unsubscribeFromAuthClient) unsubscribeFromAuthClient = authClient.subscribe(() => (sharedPendingTokenPromise = null));

	const currentToken = authClient.getAccessToken();
	if (currentToken) return currentToken;

	if (sharedPendingTokenPromise !== null) return sharedPendingTokenPromise;

	const timeout = new Promise<never>((_, reject) =>
		setTimeout(() => {
			sharedPendingTokenPromise = null;
			reject(new Error("Token retrieval timed out"));
		}, TOKEN_RETRIEVAL_TIMEOUT),
	);

	sharedPendingTokenPromise = Promise.race([timeout, authClient.getAccessTokenAsync()]).catch((error) => {
		sharedPendingTokenPromise = null;
		throw error;
	});

	return sharedPendingTokenPromise;
};

/** Registers a component/store relying on authClient (via apiService) */
export const registerAuthConsumer = (subscriberId: string) => {
	authConsumers.add(subscriberId);
};

/** Unregisters a component/store relying on authClient (via apiService) */
export const unregisterAuthConsumer = (subscriberId: string) => {
	authConsumers.delete(subscriberId);
	if (authConsumers.size) return;

	unsubscribeFromAuthClient?.();
	unsubscribeFromAuthClient = null;

	sharedPendingTokenPromise = null;
};
